<template>
    <div class="loading-message">
        <div class="spinner"></div>
        <span class="loading-text">Думаю</span><span class="dots"><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span>
    </div>
</template>

<style lang="scss" scoped>
.loading-message {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px;
    padding-left: 0;
    align-self: flex-start;
}

.spinner {
    width: 16px;
    height: 16px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-top-color: var(--color-blue);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    flex-shrink: 0;
}

.loading-text {
    font-size: 14px;
    font-weight: 300;
    background: linear-gradient(
        90deg,
        var(--color-border) 0%,
        var(--color-blue) 50%,
        var(--color-border) 100%
    );
    background-size: 200% 100%;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: shimmer 2s ease-in-out infinite;
}

.dots {
    font-size: 14px;
    font-weight: 500;
    color: var(--color-blue);

    .dot {
        display: inline-block;
        opacity: 0;
        animation: fade-dot 1.5s ease-in-out infinite;

        &:nth-child(1) { animation-delay: 0s; }
        &:nth-child(2) { animation-delay: 0.3s; }
        &:nth-child(3) { animation-delay: 0.6s; }
    }
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

@keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

@keyframes fade-dot {
    0%, 20% { opacity: 0; }
    40%, 60% { opacity: 1; }
    80%, 100% { opacity: 0; }
}
</style>
